import getAPIResponse from "../common/Common";

export async function getAllPlayers() {
	return await getAPIResponse("/api/v1/admin/players");
}